import React, { Component } from 'react'
import { Template as TemplateModel } from "app/types/model-types";

import {
    css,
    Icon,
    Theme,
} from "@bdfx/mergado-ui-kit";

import { getTemplateProgress } from "app/helpers/api";
import { AxiosResponse } from "axios";
import trans from 'trans';
import { IconSimilarity } from 'app/icons';

interface Props {
    template: TemplateModel
}

interface State {
    isLoading: boolean
    templateProgress: TemplateProgressResponseType
}

type TemplateProgressResponseType = {
    visual_similarity_to_be_processed: number
    should_rerender_count: number
    should_redownload_count: number
}

const iconsize = 16
const iconcolor = Theme.steelblue

class TemplateProgress extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            templateProgress: null,
        }
    }

    componentDidMount() {
        const { template } = this.props

        this.setState({ isLoading: true })
        getTemplateProgress(template.id)
            .then((response: AxiosResponse<TemplateProgressResponseType>) => {
                this.setState({ templateProgress: response.data })
            })
            .catch(e => {
                console.error(`error while loading progress ${template.id}`, e)
            })
            .finally(() => {
                this.setState({ isLoading: false })
            })
    }

    render() {
        const { isLoading, templateProgress } = this.state

        if (!templateProgress || isLoading) {
            return <div />
        }            

        return (<StyledProgressBars className={'unselectable'}>
            {templateProgress.visual_similarity_to_be_processed > 0 &&
                <span className='item' title={`${trans('visual_similarity')}: ${trans('to_be_processed')}`}>
                    <IconSimilarity size={iconsize} color={iconcolor} text={`${templateProgress.visual_similarity_to_be_processed}`} />
                </span>
            }

            {templateProgress.should_rerender_count > 0 &&
                <span className='item' title={trans('rerender')}>
                    <Icon type={'circle-o-notch'} size={iconsize} color={iconcolor} text={`${templateProgress.should_rerender_count}`} />
                </span>
            }

            {templateProgress.should_redownload_count > 0 &&
                <span className='item' title={trans('redownload')}>
                    <Icon type={'download-light'} size={iconsize} color={iconcolor} text={`${templateProgress.should_redownload_count}`} />
                </span>
            }
        </StyledProgressBars>)
    }
}

const StyledProgressBars = css('div')({
    marginTop: '15px',
    textAlign: 'center',
    ' item.span': {
        padding: '0 5px',
    }

})

export default TemplateProgress